<ngx-loading [show]="loading"></ngx-loading>
<div class='col-md-12 col-sm-12 col-xs-12' *ngIf="slug_status == true">
  <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-12 reviewbottom">
      <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
          <span><img [src]="business_logo" class="img-responsive" *ngIf="business_logo != null">
          <span class="bus_name_review">{{business_name}}</span></span>

      </div>
      <ng-container *ngIf="optin_status != 'OPTIN'">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
        <ng-container *ngIf="newwhatsappnumber == false">
          <p><b>{{business_name}}</b> would like to share service related information with you on your Whatsapp number. Please note, these are informational and not promotional.</p>
          <p> Kindly click <b>Yes</b>, if you're open to receiving these on your whatsapp.</p>

          <!-- <button type="button" (click)="optinBtn()" class="btn btn-secondary btn-sm reviwadd">Yes</button> -->
          <ul class="emojis">
            <li>
                <a (click)="optinBtn('yes')" class="btn btn-secondary btn-sm reviwadd mr-2" title="Yes">Yes</a>
            </li>
            <li>
                <a (click)="optinBtn('no')" title="No" class="btn btn-sm px-3 discard-btn">No</a>
            </li>
          </ul>
        </ng-container>
          <ng-container *ngIf="newwhatsappnumber1 == true">
            <p style="color: #4a4a4a;">You have <b>opted in</b> to receive Whatsapp communication from <b>{{business_name}}</b></p>
          </ng-container>
          <ng-container *ngIf="nooptin == true">
            <p style="color: #4a4a4a;">You have rejected <b>opted in</b> request to receive Whatsapp communication from <b>{{business_name}}</b></p>
          </ng-container>
        <ng-container *ngIf="newwhatsappnumber2 == true">
          <p style="color: #4a4a4a;">You have <b>opted in</b> to receive Whatsapp communication from <b>{{business_name}}</b></p>
          <p>Do update your whatsapp number if different from your regular SMS number in the text box below.</p>
          <form class="sendreviewform" [formGroup]="whatsappForm">
            <div class="row">
              <div class="form-group col-12">
                <input type="tel" [ngClass]="{'red-error-class' : isValidFormSubmitted == false && whatsappFormData.whatsapp_number.errors}" class="form-control name-text col-md-9 col-10" formControlName='whatsapp_number' placeholder="Whatsapp Number" pattern="[0-9]*" minlength=10 maxlength=10 required>
              </div>
            </div>
            <div *ngIf="whatsappFormData.whatsapp_number.errors?.pattern" class="invalid-feedback">
              <p>Number is not in correct format.</p>
            </div>
          <div class="row">
            <div class="row form-group col-12 no-padding">
            <button (click)="whatsappBtn()" [disabled]="!whatsappForm.valid" class="btn btn-secondary btn-sm reviwadd mr-2"><span><img src="assets/images/send.svg"></span>&nbsp; Submit</button>
            <button class='btn btn-sm px-3 discard-btn' type="button" (click)="whatsappBtnReset()"><span><img src="assets/images/discard.svg"></span><span class="srbtns">&nbsp;Cancel</span></button>

          </div>
        </div>
          </form>
        </ng-container>
      </div>
    </ng-container>
      <ng-container *ngIf="optin_status == 'OPTIN'">
        <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
          <p style="color: #4a4a4a;text-align:center">You already <b>optin</b> receiving Whatsapp communication from <b>{{business_name}}</b></p>
      </div>
      </ng-container>
  </div>
</div>
<footer *ngIf="slug_status == true">
    <div class="col-md-12 col-col-sm-12 col-xs-12">
      <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
          <p>Powered by</p>
        <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=optin" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
      </div>
    </div>
</footer>

<div class="container h-100 expiresec" *ngIf="slug_status == false">
  <div class="row align-items-center h-100 expiresec">
      <div class="col-6 mx-auto">
          <div class="expiretext text-center">
              <h2 class="pb-3">OOPS!</h2>
              <img src="assets/gifs/exclamation-mark.png" width="80px">
              <p class="pt-3">The link has either not found or expired</p>
          </div>
      </div>
  </div>
  <footer *ngIf="review_status == true">
      <div class="col-md-12 col-col-sm-12 col-xs-12">
          <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
              <p>Powered by</p>
        <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=optin" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
          </div>
      </div>
  </footer>
</div>



